import { ImgBlock, InfoBlock } from './styles';
import { lighten, Typography, useTheme } from '@mui/material';
import React from 'react';
import InfoIcon from '../Icons/InfoIcon';

export const Info = () => {
	const theme = useTheme();
	return (
		<InfoBlock>
			<ImgBlock>
				<InfoIcon htmlColor={lighten(theme.palette.informationAccent.main, 0.4)} sx={{ width: 34, height: 34 }}/>
			</ImgBlock>
			<Typography variant="body1" color="text.secondary">
				A loss is any time there’s been a theft, injury or damage to property, whether it was covered or not.
			</Typography>
		</InfoBlock>
	)
}
